<div *ngIf="!whitelabel else whitelabeledFooter" class="footer-container mt-sm-1 mt-md-3">
  Copyright © {{current_year}} Payarc - All rights Reserved | <a class="privacy" target="_blank" href="https://www.payarc.com/privacy-policy">Privacy</a>
</div>
<ng-template #whitelabeledFooter>
  <div class="footer-container mt-sm-1 mt-md-3">
    Copyright © {{ current_year }} {{ whitelabeledCompany }} - All rights Reserved
  </div>
</ng-template>
